import React, { useRef } from 'react';
import classNames from 'classnames';

import './PixleeOutsideButtonGroup.scss';

const PixleeOutsideButtonGroup = ({
	goToSlide, buttonGroupClassName = '', isSlideInfinite = false, ...rest
}) => {

	const {
		carouselState: { currentSlide, totalItems },
		slidesToSlide
	} = rest;

	const previousArrowRef = useRef();
	const nextArrowRef = useRef();

	const previousButtonClasses = classNames('arrowButton', 'previousArrow', 'lpIcon-scrollleft');
	const disablePreviousButton = !isSlideInfinite && currentSlide === 0;

	const totalDisplayedItems = currentSlide + slidesToSlide;
	const remainingSlides = totalItems - totalDisplayedItems;

	const nextButtonClasses = classNames('arrowButton', 'nextArrow', 'lpIcon-scrollright');
	const disableNextButton = !isSlideInfinite && remainingSlides <= 0;

	const nextArrowAction = () => {

		if (remainingSlides >= slidesToSlide) {

			goToSlide(currentSlide + slidesToSlide);

		} else if (remainingSlides) {

			goToSlide(currentSlide + remainingSlides);

		} else if (isSlideInfinite) {

			goToSlide(0);

		}

	};

	const prevArrowAction = () => {

		if (currentSlide >= slidesToSlide) {

			goToSlide(currentSlide - slidesToSlide);

		} else if (isSlideInfinite) {

			goToSlide(totalItems - 1);

		} else {

			goToSlide(0);

		}

	};

	const nextArrowkeyDown = (e) => {

		if (e.which === 9 && e.shiftKey === true && disablePreviousButton === false) {

			e.preventDefault();
			previousArrowRef.current.focus();

		}

	};

	const previousArrowkeyDown = (e) => {

		// tab
		if (e.which === 9 && e.shiftKey === false && disablePreviousButton === false) {

			e.preventDefault();
			// Below selectors are applicable only for pages those have sliders to show Pixlee data. Eg - Homepage, PDP.
			const pixleeParentContainers = document.querySelectorAll(
				'#pixleeWidgetHomeScrollMarker, #pixleeWidgetProsScrollMarker,#tipsWidgetElement, #pixleeWidgetScrollMarker, #productCompleteTheLook, #AppShopByRoomDetail'
			);

			const pixleeParentContainer = findPixleeParentContainer(
				pixleeParentContainers,
				pixleeParentContainers.length - 1
			);

			if (pixleeParentContainer.querySelector('.react-multi-carousel-item--active button')) {

				pixleeParentContainer.querySelector('.react-multi-carousel-item--active button').focus();

			} else {

				nextArrowRef.current.focus();

			}

		}

		// shift+tab

		if (e.which === 9 && e.shiftKey === true && disablePreviousButton === false) {

			// Below selectors are applicable only for pages those have sliders to show Pixlee data. Eg - Homepage, PDP.
			const pixleeParentContainers = document.querySelectorAll(
				'#pixleeWidgetHomeScrollMarker, #pixleeWidgetProsScrollMarker,#tipsWidgetElement, #pixleeWidgetScrollMarker, #productCompleteTheLook'
			);

			const pixleeParentContainer = findPixleeParentContainer(
				pixleeParentContainers,
				pixleeParentContainers.length - 1
			);

			const previousElement = pixleeParentContainer
				? findPrevTabableElement(pixleeParentContainer)
				: pixleeParentContainers[0] && findPrevTabableElement(pixleeParentContainers[0]);

			if (previousElement) {

				previousElement.setAttribute('tabindex', '0');
				e.preventDefault();
				previousElement.focus();

			}

		}

	};

	const findPixleeParentContainer = (parentsContainers, length) => {

		if (length == -1 || length === 0) {

			return parentsContainers[0];

		}
		const btnGrpClassName = buttonGroupClassName ? `.${buttonGroupClassName}` : '.PixleeOutsideButtonGroup';

		if (parentsContainers[length]?.querySelector(`${btnGrpClassName}`)) {

			return parentsContainers[length];

		}
		return findPixleeParentContainer(parentsContainers, length - 1);

	};

	const findPrevTabableElement = (SourceElement) => {

		if (SourceElement) {

			const childElements = SourceElement.previousElementSibling.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			if (childElements.length) {

				return childElements[childElements.length - 1];

			}
			return findPrevTabableElement(SourceElement.previousElementSibling);

		}

		return null;

	};
	return (
		<div className={`PixleeOutsideButtonGroup ${buttonGroupClassName}`}>
			<button
				type="button"
				className={previousButtonClasses}
				onClick={prevArrowAction}
				disabled={disablePreviousButton}
				aria-label="Previous"
				onKeyDown={previousArrowkeyDown}
				ref={previousArrowRef}
			/>
			<button
				type="button"
				className={nextButtonClasses}
				onClick={!disableNextButton ? nextArrowAction : null}
				disabled={disableNextButton}
				aria-label="Next"
				onKeyDown={nextArrowkeyDown}
				ref={nextArrowRef}
			/>
		</div>
	);

};

export const PixleeOutsideRightButton = ({
	buttonGroupClassName = '',
	isSlideInfinite = false,
	carouselObj,
	slidesToSlide,
	carouselState
}) => {

	if (!carouselState) return null;
	const { goToSlide } = carouselObj;
	const { currentSlide, totalItems } = carouselState;
	const nextArrowRef = useRef();

	const totalDisplayedItems = currentSlide + slidesToSlide;
	const remainingSlides = totalItems - totalDisplayedItems;

	const nextButtonClasses = classNames('arrowButton', 'nextArrow', 'lpIcon-scrollright');
	const disableNextButton = !isSlideInfinite && remainingSlides <= 0;
	const nextArrowAction = () => {

		if (remainingSlides >= slidesToSlide) {

			goToSlide(currentSlide + slidesToSlide);

		} else if (remainingSlides) {

			goToSlide(currentSlide + remainingSlides);

		} else if (isSlideInfinite) {

			goToSlide(0);

		}

	};

	return (
		<div className={`PixleeOutsideButtonGroup ${buttonGroupClassName}`}>
			<button
				type="button"
				onClick={() => nextArrowAction()}
				className={nextButtonClasses}
				disabled={disableNextButton}
				aria-label="Next"
				ref={nextArrowRef}
			/>
		</div>
	);

};

export const PixleeOutsideLeftButton = ({
	buttonGroupClassName = '',
	isSlideInfinite = false,
	carouselObj,
	slidesToSlide,
	carouselState
}) => {

	if (!carouselState) return null;

	const { goToSlide } = carouselObj;
	const { currentSlide, totalItems } = carouselState;
	const previousArrowRef = useRef();

	const previousButtonClasses = classNames('arrowButton', 'previousArrow', 'lpIcon-scrollleft');
	const disablePreviousButton = !isSlideInfinite && currentSlide === 0;
	const prevArrowAction = () => {

		if (currentSlide >= slidesToSlide) {

			goToSlide(currentSlide - slidesToSlide);

		} else if (isSlideInfinite) {

			goToSlide(totalItems - 1);

		} else {

			goToSlide(0);

		}

	};
	return (
		<div className={`PixleeOutsideButtonGroup ${buttonGroupClassName}`}>
			<button
				type="button"
				onClick={prevArrowAction}
				className={previousButtonClasses}
				disabled={disablePreviousButton}
				aria-label="Previous"
				ref={previousArrowRef}
			/>
		</div>
	);

};

export default PixleeOutsideButtonGroup;
